// DS2.5
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../PlainButtonOrLink';
import { IconSize } from '../../Icons/IconWrap';
import SimpleTooltip from '../../tooltips/dsPreset/SimpleTooltip';
import s from './IconButton.scss';
const IconButton = (_param)=>{
    var { size, className, icon: IconComponent, variant = 'main', tooltipText } = _param, props = _object_without_properties(_param, [
        "size",
        "className",
        "icon",
        "variant",
        "tooltipText"
    ]);
    const icon = /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        size: size === 'small' ? IconSize.SMALLER : IconSize.MEDIUM,
        disableDefaultColors: true
    });
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: classnames(s['root'], s[`size-${size}`], variant && s[`variant-${variant}`], props.disabled && s['disabled'], className)
    }, props), tooltipText ? /*#__PURE__*/ React.createElement(SimpleTooltip, {
        usePortal: true,
        text: tooltipText
    }, icon) : icon);
};
IconButton.displayName = 'IconButton';
export default IconButton;
